import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
const API = `${process.env.REACT_APP_BACKEND_URL}/api/superadmin/maintenance/plan-cutover`;
export default function PlanCutoverTab() {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [backup, setBackup] = useState(false);
  const [paused, setPaused] = useState(false);
  const [confirm, setConfirm] = useState('');
  const refresh = async () => {
    const r = await fetch(API, { credentials: 'include' });
    const d = await r.json();
    if (!r.ok) throw new Error(d.detail || 'Impossibile verificare la migrazione');
    setState(d);
  };
  useEffect(() => { refresh().catch(e => setError(e.message)); }, []);
  const run = async (operation) => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/${operation}`, { method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ backup_confirmed: backup, writes_paused_confirmed: paused, confirmation: confirm }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Operazione non riuscita');
      setState(d); setConfirm('');
    } catch (e) { setError(e.message); await refresh().catch(() => {}); }
    finally { setBusy(false); }
  };
  const toggle = async (enabled) => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/toggle`, { method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Operazione non riuscita');
      setState(d);
      setPaused(false);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  const done = ['ready_for_cutover', 'completed'].includes(state?.status);
  const enabled = !!state?.maintenance_enabled && !state?.running && backup && paused;
  return <section className="surface p-5 max-w-3xl space-y-4">
    <h2 className="font-heading text-lg">Migrazione iniziale licenze</h2>
    <p className="text-sm text-slate-600">Operazione temporanea una tantum. Non è la migrazione delle aziende tra versioni di piano. Non elimina i campi legacy.</p>
    {error && <div role="alert" className="rounded border border-red-300 p-3 text-sm text-red-700">{error}</div>}
    <div className="rounded-lg border p-3 text-sm space-y-1"><p>Stato: <b>{state?.status || 'caricamento'}</b></p>
      <p>Licenze senza versione: <b>{state?.legacy_licenses ?? '—'}</b> · Richieste senza versione: <b>{state?.legacy_requests ?? '—'}</b></p>
      <p>Stato procedura: <b>{state?.maintenance_enabled ? 'Attiva' : 'Non attiva'}</b></p>
      <p className="text-amber-700">Questo comando non sospende login, API o operazioni già in corso. La sospensione delle scritture va effettuata e verificata separatamente.</p>
      <Button variant="outline" disabled={busy || state?.running} onClick={() => toggle(!state?.maintenance_enabled)}>{state?.maintenance_enabled ? 'Disattiva manutenzione' : 'Attiva manutenzione'}</Button>
      {state?.report?.differences?.length > 0 && <p className="text-red-700">Differenze rilevate: {state.report.differences.length}</p>}
      {state?.report?.invalid_links?.length > 0 && <p className="text-red-700">Riferimenti non validi: {state.report.invalid_links.length}</p>}</div>
    {!done && <div className="space-y-3">
      <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={backup} onChange={e => setBackup(e.target.checked)} />Ho eseguito e verificato un backup MongoDB ripristinabile.</label>
      <label className="flex items-start gap-2 text-sm"><input type="checkbox" checked={paused} onChange={e => setPaused(e.target.checked)} />Le scritture di licenze, registrazioni e richieste sono realmente sospese su tutte le istanze.</label>
      <div className="flex flex-wrap gap-2"><Button variant="outline" disabled={!enabled || busy} onClick={() => run('check')}>1. Verifica compatibilità</Button>
      <Button disabled={!enabled || busy || state?.status !== 'preflight_passed' || confirm !== 'MIGRA LICENZE'} onClick={() => run('apply')}>2. Esegui migrazione</Button></div>
      {state?.status === 'preflight_passed' && <div><label className="text-sm block mb-1">Per autorizzare, digita MIGRA LICENZE</label><input className="rounded border p-2 w-full max-w-xs" value={confirm} onChange={e => setConfirm(e.target.value)} /></div>}
    </div>}
    {done && <p className="text-sm text-emerald-700">Migrazione preparata. Verifica i flussi reali prima di qualsiasi cleanup. Il pulsante non elimina dati legacy.</p>}
    <Button variant="outline" disabled={busy} onClick={() => refresh().catch(e => setError(e.message))}>Aggiorna stato</Button>
  </section>;
}
